import React from 'react';
import { Link } from 'react-router-dom';

import { Button } from 'antd';

interface IProps {
  resetErrorState: () => void;
}

const Error = ({ resetErrorState }: IProps) => {
  const handleNavigateToMain = () => {
    resetErrorState();
  };

  return (
    <div>
      <div className='[&_h1]:text-content-subtitle [&_h2]:text-content-subtitle flex min-h-[70vh] flex-col items-center justify-center px-4 text-center sm:px-6 md:mx-auto md:max-w-screen-xl md:px-8 [&_h1]:text-[2.5rem] [&_h1]:leading-6 [&_h1]:font-semibold [&_h2]:text-base'>
        <div className='notfound'>
          <h1 className='m-0!'>Tente novamente</h1>
          <br />
          <h2 className='m-0!'>A página não pôde ser carregada. Tente novamente mais tarde.</h2>
          <br />
        </div>
        <Link to='/' onClick={handleNavigateToMain}>
          <Button type='primary'>Ir para tela principal</Button>
        </Link>
      </div>
    </div>
  );
};

export default Error;
